export default __webpack_public_path__ + "static/media/Definix-guide2-05.1ce9c802.png";